export class UserRegistrationDto {
  constructor(public email: string, public userName: string, public password: string, public timezone: string, public gclid?: string,
              public signupReferrer?: string, public utmSource?: string, public utmMedium?: string, public utmCampaign?: string,
              public postConfirmRedirect?: string, public newsletter?: boolean) {}
}
